import React from "react";
import Header from "../components/Header1";
import Footer from "../components/Footer";
import { isWebview } from "../util/generalFunction";
import '../styles/styles.min.css';
// import '../styles/bootstrap.min.css';

const Layout = ({ children }) => (
  <div className="container-fluid no-padding">
    <Header />
    {/* <div className="pt-5 w-100 h-100">
      <div className="p-3 w-100 h-100">{children}</div>
    </div> */}
    {children}
    {isWebview() ? null : <Footer />}
  </div>
);

export default Layout;



// WEBPACK FOOTER //
// ./layout/Layout.js